import { CREATE_ORDER, APPROVE_REJECT_ORDER, EDIT_ORDER, LIST_ORDER, VIEW_ORDER } from "./types";


export const createOrderAction = (data, onSuccess, onError) => {
    return {
        type: CREATE_ORDER,
        data,
        onSuccess,
        onError,
    };
};

export const editOrderAction = (data, onSuccess, onError) => {
    return {
        type: EDIT_ORDER,
        data,
        onSuccess,
        onError,
    };
};

export const listOrderAction = (data, onSuccess, onError) => {
    return {
        type: LIST_ORDER,
        data,
        onSuccess,
        onError,
    };
};

export const viewOrderAction = (data, onSuccess, onError) => {
    return {
        type: VIEW_ORDER,
        data,
        onSuccess,
        onError,
    };
};

export const approveRejectOrderAction = (data, onSuccess, onError) => {
    return {
        type: APPROVE_REJECT_ORDER,
        data,
        onSuccess,
        onError,
    };
};